<div class="ft2">
    <div class="ft2-page-overlay bg-blue-dark-gradient v-center h-center pb-8">
        <div class="ft2-container text-center py-3">
            <img class="mb-5 mb-xs-1" width="85" [src]="'assets/img/ft2-badge-logo.png' | ftFilePath " alt="">
            <ng-content></ng-content>
        </div>
    </div>
</div>
